import React, {useEffect, useRef, useState} from 'react';
// @ts-ignore
import scss from './loaderPDF.module.scss';

type LoaderProps = {
    loadingProgress: number;
    totalPages: number;
    onAnimationEnd?: () => void; // новый пропс для события конца анимации
};

const LoaderPDF: React.FC<LoaderProps> = ({ loadingProgress, totalPages, onAnimationEnd }) => {
    const [animateTo100, setAnimateTo100] = useState(false);
    const progressBarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Запускаем анимацию от 0 до 100
        if (loadingProgress === 100) {  // например, loadingProgress === 100
            setAnimateTo100(false); // сначала сбросить ширину до 0
            setTimeout(() => {
                setAnimateTo100(true);  // потом включить анимацию до 100%
            }, 50); // небольшой таймаут чтобы успело примениться 0%
        }
    }, [loadingProgress]);


    useEffect(() => {
        if (animateTo100) {
            const timeout = setTimeout(() => {
                onAnimationEnd?.();
            }, 2500);

            return () => clearTimeout(timeout);
        }
    }, [animateTo100, onAnimationEnd]);

    useEffect(() => {
        const el = progressBarRef.current;
        if (!el) return;

        function handleTransitionEnd(e: TransitionEvent) {
            if (e.propertyName === "width" && animateTo100) {
                if (onAnimationEnd) onAnimationEnd();
            }
        }

        el.addEventListener("transitionend", handleTransitionEnd);

        return () => {
            el.removeEventListener("transitionend", handleTransitionEnd);
        };
    }, [animateTo100, onAnimationEnd]);


    return (
        <div
            className={scss.loaderPDFProgressBar}
            style={{
                marginBottom: "130px",
            }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "start",
                }}
            >
                <div
                    className={`${scss.loaderPDFProgressBar_line} ${!animateTo100 ? scss.pulsing : ''}`}
                    style={{
                        width: animateTo100 ? '100%' : '10%',
                        transition: animateTo100 ? 'width 2.5s linear' : 'none',
                    }}
                />
            </div>
        </div>
    );
};

export default LoaderPDF;